import React, {useEffect, useState} from 'react'
import { inputTypes } from '../../../libs/react-mpk/config/constant'
import { FormWrapper } from '../../../libs/react-mpk/wrapper'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'
import service from './PengaturanPemotonganPPh21.service'
import KopService from '../KodeObjekPajak/KodeObjekPajak.service'
import Utils from '../../../libs/custom/Utils'

const PengaturanPemotonganPPhForm = ({envStore, match, history}) => {
  const { inputTypes, definition } = FormWrapper
  const [data, setData] = useState({loading: true, content: {}})
  const [kopList, setKopList] = useState([])
  const [isEdit, setIsEdit] = useState(false)

  // initial data
  useEffect(() => {
    _getKop()

    async function initData() {
      if(match.params.id == 'baru') {
        setData({loading: false, content: {keterangan: ''}})
        return true
      }
      const res = await service.getOne(match.params.id)
      res.data = Utils.formSerialize(res.data)
      setIsEdit(true)
      setData({loading: false, content:res.data})
    }
    initData()
  }, ['match.params.id'])

  async function _getKop() {
    var res = await KopService.get({size: 100000})
    setKopList(res.data.map(x => ({value: x.id, label: x.kode?`${x.kode} - ${x.nama}`: `${x.nama}`})))
  }

  return (
    <FormWrapper
      noValidate
      loading={data.loading}
      actions={[
        {
          label: 'Reload',
          iconClassName: 'mdi mdi-reload'
        }
      ]}
      backTo={`/onpremise/pengaturan-pemotongan-pph`}
      baseId="mod-form-sample"
      title={t.translate('modules.PengaturanPemotonganPPh.formTitle')}
      // hintMessage={t.translate('modules.form.hint.message')}
      hintShowIcon={false}
      defaultData={data.content}
      definitions={[
        // =====
        {
          inputType: inputTypes.INPUT,
          label: 'Kode',
          key: 'kode',
          type: 'text',
          width: '49%',
          style: {marginRight: '2%'},
          disabled: isEdit,
          validation: 'required'
        },{
          inputType: inputTypes.INPUT,
          label: 'Nama',
          key: 'nama',
          type: 'text',
          width: '49%',
          disabled: isEdit,
          validation: 'required'
        },{
          inputType: inputTypes.SELECT,
          label: 'KOP',
          key: 'kodeObjekPajak__id',
          type: 'text',
          options: kopList,
          validation: 'required'
        },{
          inputType: inputTypes.INPUT,
          label: 'Keterangan',
          key: 'keterangan',
          type: 'text'
        },
        // -----
      ]}
      onSubmit={async (data, callback) => {
        var res = {}
        try {
          data = Utils.formNormalize(data)
          if(match.params.id == 'baru') {
            res = await service.post(data)
          } else {
            res = await service.put(data)
          }
          callback(t.translate('global.dataTelahDiSimpan'), false)
          history.push('/onpremise/pengaturan-pemotongan-pph')
        } catch(e) {
          callback(e, true, false)
        }
      }}
    />
  )
}

export default inject('envStore')(observer(PengaturanPemotonganPPhForm))
